module.exports = __webpack_public_path__ + "img/removed.0e4240a0.svg";